module.exports = "/assets/af9ac9d0e1eec0d089f901befc75722d.svg";